import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import CourseDialogConfirm from '../components/CourseDialogConfirm';
import * as FUNCTION from '../constants/FunctionConstants';
import * as Path from "../constants/PathConstants";
import * as actionType from '../constants/actionTypes/page';
import store from '../store';
import { checkChildRoute } from '../utils/PageUtils';
import { HIDDEN_STATUS } from '../constants/EnterpriseConstants';
import {
  NEW_COURSE_MANAGEMENT_URL,
  ROOT_URL,
  COURSE_LAYOUT_TYPE,
  NEW_ADMIN_MANAGEMENT_URL,
  NEW_SERVICE_MANAGEMENT_URL,
  NEW_USER_MANAGEMENT_URL,
  NEW_GROUP_MANAGEMENT_URL,
  ENTERPRISE_SWITCHING_MANAGEMENT_URL,
  CONTENT_GROUP_MANAGEMENT_URL,
  MAIL_TEMPLATE_USERS_URL,
} from "../constants";
import { EDIT_ACCOUNT_VALUE } from '../constants/LocalStorageConstants';

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showConfirmModal: false,
    };

    this.toggle = this.toggle.bind(this);
    this.reloadComponent = this.reloadComponent.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.onSelectNewLayout = this.onSelectNewLayout.bind(this);
    this.onSelectOldLayout = this.onSelectOldLayout.bind(this);
  }

  reloadComponent() {
    store.dispatch({
      type: actionType.RELOAD_COMPONENT,
    });
  }

  toggle() {
    this.setState({ open: !this.state.open });
  }

  openConfirmDialog(mdContent, mdSize) {
    const { history } = this.props;
    if (localStorage.getItem('courseLayoutType') === COURSE_LAYOUT_TYPE.NEW) {
      window.location.href = NEW_COURSE_MANAGEMENT_URL;
    } else if (localStorage.getItem('courseLayoutType') === COURSE_LAYOUT_TYPE.OLD) {
      history.push(Path.COURSE_LIST);
    } else {
      this.content = mdContent;
      this.mdSize = mdSize;
      this.setState({ showConfirmModal: true });
    }
  }

  // Step11.0.0 START
  redirectToNewScreen(path) {
    let redirectURL = '';
    if (path === Path.SUPERUSER_LIST) {
      redirectURL = NEW_ADMIN_MANAGEMENT_URL;
    } else if (path === Path.SERVICE_LIST) {
      redirectURL = NEW_SERVICE_MANAGEMENT_URL;
    } else if (path === Path.USER_LIST) {
      redirectURL = NEW_USER_MANAGEMENT_URL;
    } else if (path === Path.GROUP_LIST) {
      redirectURL = NEW_GROUP_MANAGEMENT_URL;
    } else if (path === Path.ENTERPRISE_SWITCHING) {
      redirectURL = ENTERPRISE_SWITCHING_MANAGEMENT_URL;
    } else if (path === Path.CONTENT_GROUP) {
      redirectURL = CONTENT_GROUP_MANAGEMENT_URL;
    } else if (path === Path.MAIL_TEMPLATE_USERS) {
      redirectURL = MAIL_TEMPLATE_USERS_URL;
    }
    redirectURL !== '' && (window.location.href = redirectURL);
  }
  // Step11.0.0 END

  onSelectNewLayout() {
    window.saveItem('courseLayoutType', COURSE_LAYOUT_TYPE.NEW);
    window.sendItem('courseLayoutType', COURSE_LAYOUT_TYPE.NEW);
    window.location.href = NEW_COURSE_MANAGEMENT_URL;
  }

  onSelectOldLayout() {
    const { history } = this.props;
    this.setState({
      showConfirmModal: false,
    });
    window.saveItem('courseLayoutType', COURSE_LAYOUT_TYPE.OLD);
    window.sendItem('courseLayoutType', COURSE_LAYOUT_TYPE.OLD);
    history.push(Path.COURSE_LIST);
  }

  renderItem(title, path, disabled, url, icon, line, lineTop) {
    const isTop = path === Path.TOP_LIST;
    if (path === url) {
      return (
        <>
          <li className="active" onClick={this.reloadComponent}>
            <div className={"nav-item menu menu-" + icon}>
              {/* {!ICON.LARGE_MENU.includes(icon) && (<img src={SubMenu} alt="line" />)} */}
              {/* getIcon(icon) */ }
              <span>{`${title}`}</span>
            </div>
          </li>
          {line && <hr className={`${isTop == true ? "margin-top-4" : ""}`} />}
        </>
      );
    }
    if (disabled) {
      return (
        <LinkContainer to="#" className={checkChildRoute(url, path) ? 'active' : ''}>
          <li 
              disabled={disabled ? 'disabled' : ''}>
            <div className={"nav-item menu menu-" + icon}>
              {/* {!ICON.LARGE_MENU.includes(icon) && (<img src={SubMenu} alt="line" />)} */}
              {/* getIcon(icon) */}
              <span>{`${title}`}</span>
            </div>
          </li>
        </LinkContainer>
      );
    }
    // Step10.0.0 START
    // STEP10.2.0 START
    // Step11.0.0 START
    // Step12.0.0 START
    const isRedirectToNewScreen =
      path === Path.SUPERUSER_LIST ||
      path === Path.SERVICE_LIST ||
      path === Path.USER_LIST ||
      path === Path.GROUP_LIST ||
      path === Path.ENTERPRISE_SWITCHING ||
      path === Path.CONTENT_GROUP ||
      path === Path.MAIL_TEMPLATE_USERS;
    // Step12.0.0 END
    if (isRedirectToNewScreen) {
      return (
        <li
          onClick={() => this.redirectToNewScreen(path)}
        >
          <div className={"nav-item menu menu-" + icon}>
            <span>{`${title}`}</span>
          </div>
        </li>
      );
    }
    // Step11.0.0 END
    if (path === Path.SERVICE_DETAIL) {
      const serviceCd = url.substring(url.lastIndexOf('/') + 1);
      path = path.replace(':id', serviceCd);
    }
    // STEP10.2.0 END
    if (path === Path.COURSE_LIST) {
      return (
        <>
          <li
            onClick={this.openConfirmDialog}
          >
            <div className={"nav-item menu menu-" + icon}>
              <span>{`${title}`}</span>
            </div>
          </li>
          <CourseDialogConfirm
            showModal={this.state.showConfirmModal}
            mdSize={this.mdSize}
            onSelectNewLayout={this.onSelectNewLayout}
            onSelectOldLayout={this.onSelectOldLayout}
          />
        </>
      );
    }
    // Step10.0.0 END
    return (
      <>
      <LinkContainer to={path} className={checkChildRoute(url, path) ? 'active' : ''}>
        <li onClick={this.reloadComponent}>
          <div className={"nav-item menu menu-" + icon}>
            {/* {!ICON.LARGE_MENU.includes(icon) && (<img src={SubMenu} alt="line" />)} */}
            {/* getIcon(icon) */}
            <span>{`${title}`}</span>
          </div>
        </li>
      </LinkContainer>
      {line && <hr className={`${isTop == true ? "margin-top-4" : ""}`} />}
      </>
    );
  }

  renderCollapseItem({ id, title, child, disabled, url, icon, line, history}) {
    const { open } = this.state;
    const className = open ? 'open' : '';
    const isSystemGroup = id === FUNCTION.G_SYSTEM;
    if (disabled) {
      return (
        <li className={className} disabled={disabled ? 'disabled' : ''}>
          <div className="nav-item" onClick={this.toggle}>
            {/* getIcon(icon) */}
            <span role="presentation" className={className}>
              {`${title}`}
            </span>
          </div>
          <div>
            <Collapse in={open} className="padding" timeout={10}>
              <ul className="left-menu">
                {child.map(itemData => <ItemList key={itemData.id} data={itemData} url={url} />)}
              </ul>
            </Collapse>
          </div>
        </li>
      );
    }
    return (
      <>
        {child.map(itemData => <ItemList key={itemData.id} data={itemData} url={url} history={history} />)}
        {line && <hr className={`${isSystemGroup == true ? "margin-top-8 margin-bottom-8" : ""}`} />}
      </>
    )
  }

  render() {
    const {
      data,
      url,
      logout,
      history,
      openPage,
      hiddenStatus,
      isShowContract,
      isTrialExpire,
      isOEMUser,
    } = this.props;
    const { id, title, path, child, disabled, icon, line, lineTop } = data;
    // Step 9.0.1 START
    if (id === FUNCTION.LOGOUT) {
      return (
        <li onClick={logout}>
          <div className="nav-item menu logout">
            <span>ログアウト</span>
          </div>
        </li>
      );
    }
    // Step 11.0.0 START
    if (id === FUNCTION.CONTACT) {
      if (!isOEMUser && !isTrialExpire && (hiddenStatus === HIDDEN_STATUS.SHOW_ALL && !isShowContract)) {
        return (
          <li onClick={openPage}>
            <div className="nav-item menu contact">
              <span>問い合わせ</span>
            </div>
          </li>
        );
      }
      return null;
    }
    if (id === FUNCTION.FAQ) {
      if (
        !isOEMUser &&
        !isTrialExpire &&
        ((!isShowContract && hiddenStatus !== HIDDEN_STATUS.HIDE_ALL) || isShowContract)
      ) {
        return (
          <li onClick={openPage}>
            <div className="nav-item menu faq">
              <span>マニュアル</span>
            </div>
          </li>
        );
      }
      return null;
    }
    // Step 11.0.0 END
    // Step 9.0.1 END
    if (child) {
      return this.renderCollapseItem({ id, title, child, disabled, url, icon, line, history });
    }
    return this.renderItem(title, path, disabled, url, icon, line, lineTop);
  }

}

export default ItemList;